/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { Text, View } from '@az/starc-ui';
import Image from '@/components/NextImage';
import type { BadgeType } from '../../../interface/types';

const labelMap = {
  originallyPostedOn: 'label_reviews_originallyPostedOn',
};

export const Syndicated = ({ contentType, badgeType }: BadgeType) => {
  const labels = useLabels(labelMap);

  return (
    <View className={styles.syndicatedContainer}>
      {contentType ? <Image src={contentType} width={47} height={30} alt="" /> : null}
      <Text variant="main-body">{`${labels.originallyPostedOn} ${badgeType}`}</Text>
    </View>
  );
};
